import * as React from 'react'
import { defineMessages, FormattedHTMLMessage, FormattedMessage, MessageDescriptor } from 'react-intl'
import styles from './simpleFaq.module.scss'

interface ISimpleFaqProps {
  customQas?: {
    q: MessageDescriptor
    a: MessageDescriptor
  }[]
  customHeading?: MessageDescriptor
}

const messages = defineMessages({
  heading: {
    defaultMessage: 'FAQ - Dina frågor besvarade',
    id: 'consultant.faq.heading',
  },
  question1: {
    defaultMessage: 'Kan jag göra löner via Dooer?',
    id: 'consultant.faq.question-1',
  },
  answer1: {
    defaultMessage:
      'Ja, med Dooer kan du skapa löner enklare än någonsin med unik överblick i realtid. Allt annat tar vi hand om. Du kan ha obegränsat antal anställda, olika löneperioder, lönespecifikationer, förmåner, semesterhantering, utlägg och massor av andra saker ingår.',
    id: 'consultant.faq.answer-1',
  },
  question2: {
    defaultMessage: 'Vad kostar det?',
    id: 'consultant.faq.question-2',
  },
  answer2: {
    defaultMessage:
      'Hos oss styr ditt företags behov allt. Du har alltid full kostnadskontroll och den tid för råd och stöd som du behöver för ett tryggt företagande. Ett smart fastpris från 995 kronor i månaden.',
    id: 'consultant.faq.answer-2',
  },
  question3: {
    defaultMessage: 'Hur lång tid tar det att byta till Dooer?',
    id: 'consultant.faq.question-3',
  },
  answer3: {
    defaultMessage:
      'Har du ett nystartat företag som kommer vi igång direkt. Flyttar du till oss så behöver vi få din bokföring från din nuvarande byrå. Din nuvarande byrå måste även göra klart innevarande månad samt hanterat passerade momsperioder innan vi tar över.',
    id: 'consultant.faq.answer-3',
  },
  question4: {
    defaultMessage: 'Är det svårt att byta till Dooer?',
    id: 'consultant.faq.question-4',
  },
  answer4: {
    defaultMessage:
      'Nej, vi tar hand om allt för att din byråbyte ska gå så smidigt som möjligt. Vi har en standardiserad process för överlämning, skulle du behöva något utöver det så kan vi såklart lösa det också.',
    id: 'consultant.faq.answer-4',
  },
  question5: {
    defaultMessage: 'Vad skiljer Dooer från en traditionell byrå?',
    id: 'consultant.faq.question-5',
  },
  answer5: {
    defaultMessage:
      'Massor. Vi erbjuder samma tjänster som en större traditionell byrå. Men hos oss får du mycket, mycket mer. Förutom seniora ekonomer, rådgivare och affärsutvecklare får du också supersmart teknik och processer specialutvecklade för att passa dig som företagare. ',
    id: 'consultant.faq.answer-5',
  },
  question6: {
    defaultMessage: 'Vem gör min bokföring?',
    id: 'consultant.faq.question-6',
  },
  answer6: {
    defaultMessage:
      'Din bokföring görs av din personliga seniora ekonom på något av våra kontor i Sverige. Just nu finns vi i Stockholm, Västerås och Jönköping, snart expanderar vi till ännu fler städer. Alla våra ekonomer får dessutom stöd av AI som genomför hundratals checkar av alla moment – som en revision i realtid.',
    id: 'consultant.faq.answer-6',
  },
})

const qas = [
  {
    q: messages.question1,
    a: messages.answer1,
  },
  {
    q: messages.question2,
    a: messages.answer2,
  },
  {
    q: messages.question3,
    a: messages.answer3,
  },
  {
    q: messages.question4,
    a: messages.answer4,
  },
  {
    q: messages.question5,
    a: messages.answer5,
  },
  {
    q: messages.question6,
    a: messages.answer6,
  },
]

export default function Faq({ customQas, customHeading }: ISimpleFaqProps) {
  return (
    <div className={styles.root}>
      <div className={styles.inner}>
        {customHeading ? (
          <FormattedHTMLMessage tagName="h2" {...customHeading} />
        ) : (
          <FormattedHTMLMessage tagName="h2" {...messages.heading} />
        )}
        <div className={styles.items}>
          {customQas
            ? customQas.map((item) => (
                <div key={item.q.defaultMessage}>
                  <FormattedHTMLMessage tagName="h4" {...item.q} />
                  <FormattedHTMLMessage tagName="p" {...item.a} />
                </div>
              ))
            : qas.map((item) => (
                <div key={item.q.defaultMessage}>
                  <FormattedMessage tagName="h4" {...item.q} />
                  <FormattedMessage tagName="p" {...item.a} />
                </div>
              ))}
        </div>
      </div>
    </div>
  )
}
